var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.926,
    height: 28,
    viewBox: "0 0 27.926 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3215",
    "data-name": "Rectangle 3215",
    width: 27.926,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28571",
    "data-name": "Group 28571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38008",
    "data-name": "Path 38008",
    d: "M33.8,6.949a.692.692,0,0,1-.691-.693V2.276H30.275V4.3a.692.692,0,1,1-1.383,0V.89h5.6V6.256a.692.692,0,0,1-.691.693",
    transform: "translate(-8.724 -0.619)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38009",
    "data-name": "Path 38009",
    d: "M2.254,16a2.292,2.292,0,0,1-.466-.048,2.236,2.236,0,0,1-1.422-.974,2.262,2.262,0,0,1,.653-3.123L12.436,3.836a2.259,2.259,0,0,1,1.552-.624H14a2.272,2.272,0,0,1,1.579.624l11.436,8.031a2.27,2.27,0,0,1,.552,3.053,2.247,2.247,0,0,1-3.115.654l-6.121-4.3a.693.693,0,0,1,.794-1.136l6.1,4.285a.868.868,0,0,0,1.183-.265A.873.873,0,0,0,26.2,12.99L14.64,4.857a.867.867,0,0,0-.614-.258h0a.893.893,0,0,0-.651.259l-.1.081L1.793,13a.88.88,0,0,0-.392.562.868.868,0,0,0,1.324.907l.064-.046,10.824-7.6a.692.692,0,0,1,.793,1.135l-10.824,7.6c-.02.016-.059.043-.1.07A2.227,2.227,0,0,1,2.254,16",
    transform: "translate(-0.003 -1.315)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38010",
    "data-name": "Path 38010",
    d: "M21.4,31.9a.692.692,0,0,1-.691-.693V24.086H16.63V31.21a.692.692,0,1,1-1.383,0V22.7h6.84V31.21a.692.692,0,0,1-.691.693",
    transform: "translate(-4.605 -7.161)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38011",
    "data-name": "Path 38011",
    d: "M26.042,34.85H4.941V22.811a.692.692,0,1,1,1.383,0V33.464H24.659V22.811a.692.692,0,1,1,1.383,0Z",
    transform: "translate(-1.494 -6.987)",
    fill: "#fc3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1ada27ede3c7f6a20bd2d0b79aaef5de.svg";
export { ForwardRef as ReactComponent };